import { type TUser as TApiUser } from '@core/api'

import { type TUser } from '@core/models'

import { convertAuthor } from './convertAuthor'

export const convertUser = (apiUser: TApiUser): TUser => {
    const { email, date_verified, date_updated, ...apiAuthor } = apiUser

    return {
        ...convertAuthor(apiAuthor),
        email,
        dateVerified: date_verified,
        dateUpdated: date_updated,
    }
}
